import { useEnvPropsStore } from '../stores/useEnvPropsStore';
import { useModalOverlayStore } from '../stores/useModalOverlayStore';
import { useShowInlineNotificationsStore } from '../stores/useShowInlineNotificationsStore';
import { useSlideoutStore } from '../stores/useSlideoutStore';

function resolveNavigationHostLink(defaultNavigationHost, ...rawValues) {
  const fallbackClientOrigin = true && window?.location?.origin ? window.location.origin : defaultNavigationHost;

  for (const rawValue of rawValues) {
    const value = typeof rawValue === 'string' ? rawValue.trim() : '';
    const hasUnresolvedToken = /(__[A-Z0-9_]+__|\$\{[A-Z0-9_]+\})/.test(value);
    const isAbsoluteHttpUrl = /^https?:\/\//i.test(value);

    if (value && !hasUnresolvedToken && isAbsoluteHttpUrl) {
      return value;
    }
  }

  return fallbackClientOrigin;
}

function resolveTokenizationPciIframeSrc(defaultTokenizationPciIframeSrc, ...rawValues) {
  for (const rawValue of rawValues) {
    const value = typeof rawValue === 'string' ? rawValue.trim() : '';
    const hasUnresolvedToken = /(__[A-Z0-9_]+__|\$\{[A-Z0-9_]+\})/.test(value);
    const isAbsoluteHttpUrl = /^https?:\/\//i.test(value);

    if (value && !hasUnresolvedToken && isAbsoluteHttpUrl) {
      return value;
    }
  }

  return defaultTokenizationPciIframeSrc;
}

export default defineNuxtPlugin(() => {
  // Register full app store definitions before atomic-ui Slideout/ModalOverlay load.
  useSlideoutStore();
  useModalOverlayStore();

  const envPropsStore = useEnvPropsStore();
  const showInlineNotificationsStore = useShowInlineNotificationsStore();
  const runtimeConfig = useRuntimeConfig();

  const entryPoint = import.meta.env.VITE_ENTRY_POINT || runtimeConfig.public.brandEntryPoint || process.env.ENTRY_POINT || 'bcom';
  const defaultNavigationHost = entryPoint === 'mcom' ? 'https://www.macys.com' : 'https://www.bloomingdales.com';
  const defaultTokenizationPciIframeSrc = entryPoint === 'mcom' ? 'https://www.macyspayments.com' : 'https://www.bloomiespayments.com';

  const navigationHostLink = resolveNavigationHostLink(
    defaultNavigationHost,
    import.meta.env.VITE_NAVIGATION_HOST_LINK,
    runtimeConfig.public.navigationHostLink,
    process.env.NAVIGATION_HOST_LINK,
    envPropsStore.navigationHostLink, // Hydrated state fallback
  );
  const tokenizationPciIframeSrc = resolveTokenizationPciIframeSrc(
    defaultTokenizationPciIframeSrc,
    import.meta.env.VITE_TOKENIZATION_PCI_IFRAME_SRC,
    runtimeConfig.public.tokenizationPciIframeSrc,
    process.env.TOKENIZATION_PCI_IFRAME_SRC,
    envPropsStore.tokenizationPciIframeSrc, // Hydrated state fallback
  );
  const tagMngrEnv = import.meta.env.VITE_TAG_MNGR_ENV || process.env.TAG_MNGR_ENV || process.env.TAG_MANAGER_ENV || 'development';

  // Set initial state for envPropsStore
  envPropsStore.headerContext = {
    deviceType: 'DESKTOP',
  };
  envPropsStore.entryPoint = entryPoint;
  envPropsStore.tagMngrEnv = tagMngrEnv;
  envPropsStore.navigationHostLink = navigationHostLink;
  envPropsStore.tokenizationPciIframeSrc = tokenizationPciIframeSrc;

  // Set initial state for showInlineNotificationsStore
  showInlineNotificationsStore.visible = false;
  showInlineNotificationsStore.message = '';
});
